// extracted by mini-css-extract-plugin
export default {"root":"JZ8xghCGbmLQZ0ZKPOkX"};